import React from 'react';
import { useHistory } from 'react-router-dom';

const pageContainer: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard: React.CSSProperties = {
  width: '100%',
  maxWidth: 900,
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: 24,
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const headerBlock: React.CSSProperties = {
  marginBottom: 20,
};

const titleStyle: React.CSSProperties = {
  fontSize: 22,
  fontWeight: 600,
  marginBottom: 4,
};

const subtitleStyle: React.CSSProperties = {
  fontSize: 13,
  opacity: 0.8,
};

const optionsRow: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
  marginTop: 8,
};

const optionCard: React.CSSProperties = {
  flex: '1 1 260px',
  minWidth: 0,
  backgroundColor: 'rgba(7, 5, 16, 0.85)',
  borderRadius: 12,
  padding: 16,
  boxSizing: 'border-box',
  border: '1px solid rgba(164, 151, 255, 0.25)',
  cursor: 'pointer',
  transition:
    'transform 120ms ease-out, box-shadow 120ms ease-out, border-color 120ms ease-out',
};

const optionCardHover: React.CSSProperties = {
  transform: 'translateY(-2px)',
  boxShadow: '0 10px 24px rgba(0,0,0,0.45)',
  borderColor: 'rgba(255,255,255,0.45)',
};

const optionTitle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 6,
};

const optionDescription: React.CSSProperties = {
  fontSize: 13,
  opacity: 0.9,
  lineHeight: 1.5,
};

const pill: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '3px 9px',
  borderRadius: 999,
  backgroundColor: 'rgba(255,255,255,0.06)',
  fontSize: 11,
  letterSpacing: 0.8,
  textTransform: 'uppercase',
  opacity: 0.9,
  marginBottom: 8,
};

const TenantNewAppointmentPage: React.FC = () => {
  const history = useHistory();
  const [hovered, setHovered] = React.useState<string | null>(null);

  const goToDelivery = () => {
    history.push('/tenant/newdelivery');
  };

  const goToPickup = () => {
    history.push('/tenant/newpickup');
  };

  return (
    <div style={pageContainer}>
      <div style={shellCard}>
        <div style={headerBlock}>
          <h1 style={titleStyle}>Schedule an appointment</h1>
          <div style={subtitleStyle}>
            Tell us what you need and we&apos;ll help you move items in or out
            of storage.
          </div>
        </div>

        <div style={optionsRow}>
          <div
            style={{
              ...optionCard,
              ...(hovered === 'delivery' ? optionCardHover : {}),
            }}
            onMouseEnter={() => setHovered('delivery')}
            onMouseLeave={() => setHovered(null)}
            onClick={goToDelivery}
          >
            <div style={pill}>From storage</div>
            <div style={optionTitle}>Deliver items to me</div>
            <div style={optionDescription}>
              Choose items that are currently stored with Bins and schedule a
              delivery back to your home, office, or another address.
            </div>
          </div>

          <div
            style={{
              ...optionCard,
              ...(hovered === 'pickup' ? optionCardHover : {}),
            }}
            onMouseEnter={() => setHovered('pickup')}
            onMouseLeave={() => setHovered(null)}
            onClick={goToPickup}
          >
            <div style={pill}>From your place</div>
            <div style={optionTitle}>Pick up items from me</div>
            <div style={optionDescription}>
              Have a driver come to you, pick up boxes or larger items, and
              move them into your storage unit for you.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantNewAppointmentPage;
